export const phoneReg = /^1[345789]\d{9}$/;
export const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
